/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useCallback } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useIntl } from 'react-intl';
import { iconSecondaryStyle } from '../EditPointsForm/iconStyles';
import Upload from '../../icons/Upload.svg?react';
import Computer from '../../icons/Computer.svg?react';
import Cloud from '../../icons/Cloud.svg?react';
import { useDropzone } from 'react-dropzone';
import ContextHelp from '../ContextHelp';
import mikeSharedTheme from '../../styles/mikeSharedTheme';

interface IProps {
  entityType: string;
  disabled?: boolean; 
  onUploadFromComputer: (files,entityType: string) => void;
  onUploadFromCLoud: (entityType: string) => void;
}

const buttonStyle = css`  
  &.MuiButtonBase-root {  
    justify-content: start; 
  }
`
const menuItemStyle = css`
  &.MuiMenuItem-root {
    height: ${mikeSharedTheme.spacing(5)};
    justify-content: space-between; 
  }
`  
const buttonLabelStyle = css`  
 padding-left: ${mikeSharedTheme.spacing(1)};
`

const MeshUpload = (props: IProps) => {
  const intl = useIntl();
  const {entityType, disabled, onUploadFromComputer, onUploadFromCLoud} = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUploadFromCloud = useCallback(() => {
    onUploadFromCLoud(entityType)
    setAnchorEl(null);
  }, [entityType, onUploadFromCLoud]);

  const handleUploadFromComputer = useCallback((files) => {
    onUploadFromComputer(files,entityType)
    setAnchorEl(null);
  }, [entityType, onUploadFromComputer]);

  const { getInputProps, getRootProps  } = useDropzone({ onDrop: handleUploadFromComputer, accept: {'.zip': ['.zip']} });  

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="text"
        color="secondary"
        onClick={handleClick}
        disabled={disabled}
      >
        <Upload css={iconSecondaryStyle(disabled)} width={24} height={24} viewBox={"0 0 40 40"}/>
        {intl.formatMessage({id: 'autoMesh.upload'})}
      </Button>
      <Menu
        elevation={0}       
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem css={menuItemStyle}>
          <Button css={buttonStyle} color='primary' variant='text' onClick={handleUploadFromCloud}>
            <Cloud/>
            <div css={buttonLabelStyle}>{intl.formatMessage({id: 'platform.cloud'})}</div>
          </Button> 
          <ContextHelp primary helpTexts={[intl.formatMessage({id: 'autoMesh.copyFromPlatform_hint'})]}/> 
        </MenuItem>
        <MenuItem css={menuItemStyle}>
          <Button css={buttonStyle} color='primary' variant={'text'} {...getRootProps()}>
            <Computer/>
            <div css={buttonLabelStyle}>{intl.formatMessage({id: 'desktop.desktop'})}</div>
            <input {...getInputProps()}/>
          </Button>
          <ContextHelp primary helpTexts={[intl.formatMessage({id: 'autoMesh.uploadShapefile_hint'})]}/>   
        </MenuItem>         
      </Menu>
    </div>
  );
}

export default MeshUpload;